import { useEffect } from "react";

const Mina = () => {
  useEffect(() => {
    // Redirect to the external URL
    window.location.href = "https://preview--mina-moein-nexus.lovable.app";
  }, []);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-white text-center">
        <p className="text-lg mb-4">Redirecting to Mina...</p>
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-white mx-auto"></div>
      </div>
    </div>
  );
};

export default Mina;